import { postData } from '../utils';

export type PostEmailSubscriptionRequest = {
  email: string;
};

export type PostEmailResponse = {
  status: number;
};

const postEmailSubscription = async (
  requestObj: PostEmailSubscriptionRequest
): Promise<PostEmailResponse> => {
  const response = await postData(`mailing/${requestObj.email}`);
  return response;
};

export default postEmailSubscription;
